import { render, staticRenderFns } from "./ProjectAuditLogStandortlisteTab.vue?vue&type=template&id=8a9295b6&scoped=true&lang=html&"
import script from "./ProjectAuditLogStandortlisteTab.vue?vue&type=script&lang=ts&"
export * from "./ProjectAuditLogStandortlisteTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAuditLogStandortlisteTab.vue?vue&type=style&index=0&id=8a9295b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9295b6",
  null
  
)

export default component.exports